import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { TextSearchService } from 'src/app/services/text-search.service';

@Component({
  selector: 'filter-text-ras',
  templateUrl: './filter-text-ras.component.html',
  styleUrls: ['./filter-text-ras.component.scss'],
})
export class FilterTextRasComponent implements OnInit {
  @Input() open;
  @Input() users;
  @Input() units;

  caseTypes;
  optionTextSearch = ['Casos', 'Tareas'];
  date = new Date();
  today = { beging: new Date(), end: new Date() };
  yesterday = {
    beging: new Date(new Date().setDate(new Date().getDate() - 1)),
    end: new Date(),
  };
  last7Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date(),
  };
  last30Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 30)),
    end: new Date(),
  };
  dates = // ['Hoy', 'Ayer', 'Últimos 7 días', 'Últimos 30 días'];
    [
      {
        value: this.today,
        name: 'Hoy',
      },
      {
        value: this.yesterday,
        name: 'Ayer',
      },
      {
        value: this.last7Days,
        name: 'Últimos 7 días',
      },
      {
        value: this.last30Days,
        name: 'Últimos 30 días',
      },
    ];
  unitId;
  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly casesService: CasesService,
    public readonly textSearchService: TextSearchService
  ) {
    this.unitId = this.route.snapshot.paramMap.get('id');
  }
  form: FormGroup = this.fb.group({
    type: [''],
    unit: [''],
    caseType: [''],
    date: [''],
    end: [''],
    beging: [''],
    assigned: [''],
  });
  ngOnInit() {
    this.textSearchService.changeType.subscribe((v: any) => {
      this.form.value.type = v
      this.form.controls.type.setValue(v)
    });
    // this.getCaseTypes();
  }
  // getCaseTypes() {
  //   this.unitsService.getTypeCases(this.unitId).subscribe({
  //     next: (caseTypes) => {
  //       this.caseTypes = caseTypes;
  //       this.form.controls.caseType.setValue(this.caseTypes[0]._id);
  //     },
  //   });
  // }

  search() {
    //this.form.controls.date.setValue(this.date);
    // console.log(this.form.value.date);
    // let date = new Date();
    // switch (this.form.value.date) {
    //   case 'Hoy':
    //     this.form.controls.beging.setValue(date);
    //     this.form.controls.end.setValue(date);
    //     break;
    //   case 'Ayer':
    //     this.form.value.date = {
    //       beging: date.setDate(date.getDate() - 1),
    //       end: new Date(),
    //     };
    //     break;
    //   case 'Últimos 7 dias':
    //     this.form.value.date = {
    //       beging: date.setDate(this.date.getDate() - 7),
    //       end: new Date(),
    //     };
    //     break;
    //   case 'Últimos 30 dias':
    //     this.form.value.date = {
    //       beging: date.setDate(this.date.getDate() - 30),
    //       end: new Date(),
    //     };
    //     break;
    // }
    if (this.form.value.date) {
      this.form.controls.beging.setValue(this.form.value.date.beging);
      this.form.controls.end.setValue(this.form.value.date.end);
    }

    this.textSearchService.filterToHeader.next(this.form.value);
  }
  cleanFilter() {
    this.form.reset();
  }
  changeUnit(value) {
    console.log(value);
  }
}
